module.exports = "<div class=\"nav\">\n\n  <div class=\"beard\">\n  </div>\n\n  <div class=\"elt\">\n      <a [routerLink]=\"['/home']\">Home</a> |\n      <a [routerLink]=\"['/products']\">Items</a>\n  </div>\n\n  <div class=\"upperimg\">\n    <img class=\"imageupper\" src=\"/assets/images/cama.png\">\n  </div>\n\n</div>\n\n<div class=\"header\">\n  <div class=\"textHeader\">\n    <img class=\"image\" src=\"/assets/images/logo.png\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/template/template.component.html
// module id = ./src/app/components/template/template.component.html
// module chunks = main